import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
  Modal,
  Row,
  Col,
} from 'react-bootstrap';

// components
import Login from './Login';

const LoginDialog = observer(
class LoginDialog extends Component {
  render() {
    let {
      show = false,
      errorMessage = "",
      userCredential,
      title = "Login",
      message = "",
      onLogin,
      confirmButtonText = "Done",
      confirmButtonStyle = "primary",
      confirmButtonDisabled = false,
      hideEmailField = false,
    } = this.props;

    return (
      <Modal show={show} onHide={this.onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message}
          <Login
            errorMessage
            userCredential={userCredential}
            onLogin={onLogin}
            hideLoginButton={true}
            hideEmailField={hideEmailField}
          />
        </Modal.Body>
        <Modal.Footer>
          <Row>
            { errorMessage &&
              <Col sm={7}>
                <div style={{"fontSize": "9pt", "textAlign": "left", "marginBottom": "15px"}}
                    className="text-danger">
                  {errorMessage}
                </div>
              </Col>
            }
            <Col sm={5}>
              <Button onClick={this.onCancel} >Cancel</Button>
              <Button
                bsStyle={confirmButtonStyle}
                disabled={confirmButtonDisabled}
                onClick={this.onLogin}>{confirmButtonText}</Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }

  onLogin = () => {
    const {
      userCredential,
      onLogin
    } = this.props;

    if (onLogin) {
      onLogin(userCredential.email, userCredential.password);
    }
  }

  onCancel = () => {
    let { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }
});

export default LoginDialog;


// WEBPACK FOOTER //
// ./src/components/Auth/LoginDialog.js